module.exports = __webpack_public_path__ + "img/284-240c6c.png";